(function () {
  function initLocalization(root) {
    var scope = root || document;
    var selectors = scope.querySelectorAll('[data-clesana-locale]');

    selectors.forEach(function (selector) {
      if (selector.dataset.clesanaLocalizationReady === 'true') return;
      if (!window.theme || !window.theme.Disclosure) return;

      selector.dataset.clesanaLocalizationReady = 'true';
      new window.theme.Disclosure(selector);
    });
  }

  function initDrawerLocalization(root) {
    var scope = root || document;
    var selectors = scope.querySelectorAll('[data-clesana-drawer-locale]');

    selectors.forEach(function (selector) {
      if (selector.dataset.clesanaDrawerLocaleReady === 'true') return;

      var toggle = selector.querySelector('[data-disclosure-toggle]');
      var list = selector.querySelector('[data-disclosure-list]');
      var input = selector.querySelector('[data-disclosure-input]');
      var form = selector.closest('[data-disclosure-form]');
      var options = selector.querySelectorAll('[data-disclosure-option]');

      if (!toggle || !list || !input || !form) return;
      selector.dataset.clesanaDrawerLocaleReady = 'true';

      function close() {
        list.classList.remove('disclosure-list--visible');
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !list.classList.contains('disclosure-list--visible');
        list.classList.toggle('disclosure-list--visible', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      options.forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          input.value = option.dataset.value;
          form.submit();
        });
      });

      selector.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close();
          toggle.focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (!selector.contains(event.target)) close();
      });
    });
  }

  function initDrawerSearch(root) {
    var scope = root || document;
    var drawerSearchButtons = scope.querySelectorAll('.clesana-nav-drawer .js-search-header');

    drawerSearchButtons.forEach(function (button) {
      if (button.dataset.clesanaDrawerSearchReady === 'true') return;
      button.dataset.clesanaDrawerSearchReady = 'true';

      button.addEventListener('click', function (event) {
        if (!window.theme || !window.theme.NavDrawer) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        // Do not return focus to the hamburger while the search field is opening.
        window.theme.NavDrawer.activeSource = null;
        window.theme.NavDrawer.close();

        window.setTimeout(function () {
          var headerSearchButton = document.querySelector('.clesana-site-header .js-search-header');
          if (headerSearchButton) headerSearchButton.click();
        }, 420);
      }, true);
    });
  }

  function init(root) {
    initLocalization(root);
    initDrawerLocalization(root);
    initDrawerSearch(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
